export const FEATURES_SETTINGS_GROUP = "FEATURES";

export const FEATURES_MAKEUPS_ENABLED_KEY = "FEATURES_MAKEUPS_ENABLED";
export const FEATURES_APPOINTMENTS_ENABLED_KEY =
  "FEATURES_APPOINTMENTS_ENABLED";
export const FEATURES_TIME_CLOCK_ENABLED_KEY = "FEATURES_TIME_CLOCK_ENABLED";
export const FEATURES_HOMEPAGE_ENABLED_KEY = "FEATURES_HOMEPAGE_ENABLED";
export const FEATURES_CHOREOGRAPHER_PORTAL_ENABLED_KEY =
  "FEATURES_CHOREOGRAPHER_PORTAL_ENABLED";
export const FEATURES_CONTRACTORS_ENABLED_KEY = "FEATURES_CONTRACTORS_ENABLED";
export const FEATURES_TICKETS_ENABLED_KEY = "FEATURES_TICKETS_ENABLED";

export interface StudioFeatureSettings {
  makeupsEnabled: boolean;
  appointmentsEnabled: boolean;
  timeClockEnabled: boolean;
  homepageEnabled: boolean;
  choreographerPortalEnabled: boolean;
  contractorsEnabled: boolean;
  ticketsEnabled: boolean;
}

export const DEFAULT_STUDIO_FEATURE_SETTINGS: StudioFeatureSettings = {
  makeupsEnabled: true,
  appointmentsEnabled: true,
  timeClockEnabled: true,
  homepageEnabled: false,
  choreographerPortalEnabled: false,
  contractorsEnabled: false,
  ticketsEnabled: false,
};

export type StudioFeatureSettingsPersisted = {
  makeups: boolean;
  appointments: boolean;
  timeClock: boolean;
  homepage: boolean;
  choreographerPortal: boolean;
  contractors: boolean;
  tickets: boolean;
};

export const DEFAULT_STUDIO_FEATURE_SETTINGS_PERSISTED: StudioFeatureSettingsPersisted =
  {
    makeups: false,
    appointments: false,
    timeClock: false,
    homepage: false,
    choreographerPortal: false,
    contractors: false,
    tickets: false,
  };

export function parseStudioFeatureFlag(
  value: string | number | boolean | null | undefined,
  fallback: boolean,
): boolean {
  if (value == null) return fallback;
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value !== 0;

  const normalized = String(value).trim().toLowerCase();
  if (normalized === "true" || normalized === "1" || normalized === "yes") {
    return true;
  }
  if (normalized === "false" || normalized === "0" || normalized === "no") {
    return false;
  }
  return fallback;
}

export function formatStudioFeatureFlag(value: boolean): string {
  return value ? "true" : "false";
}
